'use strict';

import { connect } from 'react-redux';
import React, {PropTypes} from 'react';
import {isNil} from 'lodash';

import TechnologySurveyContainer from '../../applicant/TechnologySurvey/TechnologySurveyContainer';


@connect(state => {
  return {
    dispatch: state.dispatch,
    applicant: state.admin.applicant,
    technologySurvey: state.technologySurvey,
  };
})
export default class TechnologySurvey extends React.Component {
    static propTypes = {
      dispatch: PropTypes.func.isRequired,
      staticData: PropTypes.object.isRequired,
      applicant: PropTypes.object.isRequired,
      technologySurvey: PropTypes.object.isRequired,
    }

    constructor(props) {
      super(props);
      this.state = {
        open: false,
      };
    }

    renderEmpty() {
      return (
        <div className='accordion-container steps'>
          <div className='scroll-hide'>
            <div className='technology-survey-empty' style={{height: global.innerHeight - 311 + 'px'}}>
              There is no completed technology survey for the applicant.
            </div>
          </div>
        </div>
      );
    }

    renderTechnologySurvey() {
      return (
        <div className='accordion-container steps'>
          <div className='scroll-hide'>
            <TechnologySurveyContainer
              adminView
            />
          </div>
        </div>
      );
    }

    render() {
      return (
        <div className='technology-survey-container' style={{height: global.innerHeight - 311 + 'px'}}>
          {
            this.renderTechnologySurvey()
          }
        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./shared/react/admin/TechnologySurvey/index.js